<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { Link } from 'svelte-routing';
  import { t } from '../i18nStore';
  
  export let id;

  let promo = null;
  let isLoading = true;
  let error = '';
  let brandPath = '';

  onMount(async () => {
      // Dynamically extract the brand from the URL (e.g., /it/promo/123 -> 'it')
      brandPath = window.location.pathname.split('/')[1] || '';

      try {
          const res = await fetch(getApiUrl(`/promotions/${id}`));
          if (!res.ok) throw new Error($t('partner.not_found') || "Promotion not found.");
          promo = await res.json();
      } catch (e) {
          error = e.message;
      } finally {
          isLoading = false;
      }
  });

  $: allImages = promo ? (Array.isArray(promo.images) && promo.images.length > 0 ? promo.images : [promo.imageUrl || '/public/placeholder.png']) : [];
  $: affiliateLink = promo ? (promo.hyperlink || promo.referenceUrl || promo.affiliateLink || '#') : '#';
</script>

<div class="detail-container">
  
  <!-- Back Navigation Button -->
  <div class="header-nav">
      <Link to={`/${brandPath}`} class="back-link">
          &larr; Back
      </Link>
  </div>

  {#if isLoading}
      <div class="loading">{$t('partner.loading_details') || 'Loading details...'}</div>
  {:else if error}
      <div class="error">{error}</div>
  {:else if promo}
      <div class="content-wrapper">
          
          <!-- Image Gallery -->
          <div class="gallery-section">
              {#each allImages as img}
                  <img src={img} alt={promo.name} class="gallery-image" on:error={(e) => e.target.src = '/public/placeholder.png'}/>
              {/each}
          </div>

          <!-- Info & Actions -->
          <div class="info-section">
              <h1 class="title">{promo.name}</h1>
              
              <div class="rich-description">
                  {promo.description}
              </div>

              {#if promo.promoCode}
                  <div class="promo-code-box">
                      {$t('partner.use_code') || 'Use Code:'} <strong>{promo.promoCode}</strong>
                  </div>
              {/if}

              <a href={affiliateLink} target="_blank" rel="noopener noreferrer" class="shop-button">
                  {$t('partner.shop_button') || 'Shop at Official Store'}
              </a>
          </div>

      </div>
  {/if}
</div>

<style>
  .detail-container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 2rem 1rem;
      background-color: #fff;
  }

  /* Back Button Styles */
  .header-nav {
      margin-bottom: 2rem;
  }

  .back-link {
      display: inline-flex;
      align-items: center;
      color: #666;
      text-decoration: none;
      font-size: 1rem;
      font-weight: 600;
      padding: 0.5rem 0;
      transition: color 0.2s ease;
  }

  .back-link:hover {
      color: #000;
  }

  .content-wrapper {
      display: flex;
      flex-direction: column;
      gap: 3rem;
  }

  @media (min-width: 768px) {
      .content-wrapper {
          flex-direction: row;
          align-items: flex-start;
      }
      .gallery-section {
          flex: 1.2;
          position: sticky;
          top: 2rem;
      }
      .info-section {
          flex: 1;
          padding-left: 2rem;
      }
  }

  .gallery-section {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
  }

  .gallery-image {
      width: 100%;
      height: auto;
      object-fit: cover;
      background: #f8f9fa;
  }

  .title {
      font-size: 2.5rem;
      font-weight: 800;
      color: #000;
      margin-top: 0;
      margin-bottom: 1.5rem;
      line-height: 1.2;
  }

  .rich-description {
      font-size: 1.1rem;
      line-height: 1.8;
      color: #333;
      margin-bottom: 2rem;
      white-space: pre-wrap; 
      font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', sans-serif;
  }

  .promo-code-box {
      background: #f4f4f4;
      padding: 1rem;
      text-align: center;
      font-size: 1.2rem;
      border: 1px dashed #ccc;
      margin-bottom: 2rem;
  }

  .shop-button {
      display: block;
      width: 100%;
      background: #000;
      color: #fff;
      text-align: center;
      padding: 1.2rem;
      font-size: 1.2rem;
      font-weight: bold;
      text-transform: uppercase;
      text-decoration: none;
      letter-spacing: 1px;
      transition: background 0.3s ease;
  }

  .shop-button:hover {
      background: #333;
  }

  .loading, .error {
      text-align: center;
      padding: 4rem;
      font-size: 1.2rem;
  }
</style>